import script from "./ExchangeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeView.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeView.vue?vue&type=style&index=0&id=7434da7e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7434da7e"]])

export default __exports__